// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
import { AudioHandler } from '@scarybeasties/phaser-framework-core/modules';
/* END-USER-IMPORTS */

export default class BtnAudio extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60.5, y ?? 60.5);

    // btn_png
    const btn_png = scene.add.image(0, 0, "common", "btn-top-ui-right.png");
    this.add(btn_png);

    // icon_sound_off_png
    const icon_sound_off_png = scene.add.image(3, -8, "common", "icon-sound-off.png");
    icon_sound_off_png.visible = false;
    this.add(icon_sound_off_png);

    // icon_sound_on_png
    const icon_sound_on_png = scene.add.image(3, -8, "common", "icon-sound-on.png");
    this.add(icon_sound_on_png);

    // lists
    const onList = [icon_sound_on_png];
    const offList = [icon_sound_off_png];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.onList = onList;
    thisUIButton.offList = offList;

    this.icon_sound_off_png = icon_sound_off_png;
    this.icon_sound_on_png = icon_sound_on_png;
    this.onList = onList;
    this.offList = offList;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private icon_sound_off_png: Phaser.GameObjects.Image;
  private icon_sound_on_png: Phaser.GameObjects.Image;
  private onList: Phaser.GameObjects.Image[];
  private offList: Phaser.GameObjects.Image[];

  /* START-USER-CODE */
  public awake() {
    this.setButtonState(!this.getAudioIsMuted());
    this.scene.app.AudioHandler.on(AudioHandler.events.ChannelStateMute, this.onChannelStateMuteChange, this);

    this.on(Phaser.Input.Events.POINTER_UP, () => {
      this.toggleAudio();
    });
  }

  public destroy(fromScene?: boolean | undefined): void {
    this.off(Phaser.Input.Events.POINTER_UP);
    this.scene.app.AudioHandler.off(AudioHandler.events.ChannelStateMute, this.onChannelStateMuteChange, this);
    super.destroy(fromScene);
  }

  protected getAudioIsMuted(): boolean {
    return this.scene.app.AudioHandler.getChannelMute('music');
  }

  protected onChannelStateMuteChange(channelId: string, isMuted: boolean) {
    if (channelId == 'music') this.setButtonState(!isMuted);
  }

  protected toggleAudio() {
    let isMuted = this.getAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('sfx', !isMuted);
    this.scene.app.AudioHandler.setChannelMute('music', !isMuted);
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
